var xaoi = {};
function json_encode(o){return JSON.stringify(o)}
xaoi.ws = function(url){
	var fn = function(){
		var ws = new WebSocket(url);
		ws.onopen = function(e){
			if(typeof fn.onopen === 'function')fn.onopen(e)
		};
		ws.onmessage = function(e){
			var d;
			try{d=JSON.parse(e.data);}catch(e){};

			/*if(d && typeof d[0] !== 'undefined'){
				var k = d.shift();
				if(typeof fn[k] === 'function')fn[k].apply(null,d)
			}*/
			if(d && typeof d['type'] !== 'undefined'){
				var k = d['type'];
				// var k = d.shift();
				if(typeof fn[k] === 'function')fn[k](d.data,k)
			}
		};
		ws.onerror = function(e){
			if(typeof fn.onerror === 'function')fn.onerror(e)
		};
		ws.onclose = function(e){
			if(typeof fn.onclose === 'function')fn.onclose(e)
		};

		fn.send = function(){
			/*var args = [];
			for(var i in arguments)args.push(arguments[i]);
			if(ws.readyState === 1){
				ws.send(json_encode(args));
				// console.log('连接正常');
			}
			else{
				console.log('连接断开，请刷新页面再试！');
			}*/
			ws.send(JSON.stringify(arguments[0]));

		};
		fn.getState = function(){
			return ws.readyState;
		};

		fn.close = function(){
			ws.close();
		};
	}

	return fn;
};

module.exports = xaoi